import {SoopAvatarCommon, SoopIcon, SoopLayer} from '@soop-ui/soop-ui';
import styles from './Topfan.module.scss';
import TextEllipsis from '@/components/channel/common/TextEllipsis';
import clsx from 'clsx';
import useStationSidebarMenuQuery from '@/query/channel/menu/useStationTopFansQuery';
import {useEffect, useRef} from 'react';
import {useOutsideClick} from '@/components/main/common/hooks/useOutsideClick';
import globalDomains from '@/utils/global-domains';
import ChannelIctWrapper from '@/components/channel/common/ChannelIctWrapper';
import {getUserLoginId} from '@/utils/main';
import {ChannelT, gradeOrderI18nHelper} from '@/utils/i18n/channel';

interface TopfanLayerProps {
  isCollapse?: boolean;
  streamerId: string;
  onClose: () => void;
  style?: React.CSSProperties;
}

const TopfanLayer = ({
  isCollapse = false,
  streamerId,
  onClose,
  style,
}: TopfanLayerProps) => {
  const {data: topFanList, refetch} = useStationSidebarMenuQuery({streamerId});

  useEffect(() => {
    if (!topFanList) {
      refetch();
    }
  }, [topFanList]);

  const layerRef = useRef<HTMLDivElement>(null);
  useOutsideClick(layerRef, onClose);

  const handleHomeClick = (userId: string) => {
    window.open(`${globalDomains.WWW_AFREECATV}/station/${userId}`, '_blank');
  };

  if (!topFanList) {
    return null;
  }
  return (
    <SoopLayer
      size='lg'
      onClose={onClose}
      className={clsx(styles.giftRankLayer, isCollapse && styles.collapse)}
      style={style}>
      <div ref={layerRef}>
        <SoopLayer.Header>{ChannelT('열혈팬')}</SoopLayer.Header>
        <SoopLayer.Content>
          <div className={styles.rankList}>
            <ul className={clsx(topFanList.length === 2 && styles.two)}>
              {topFanList.map((user, index) => (
                <li key={index}>
                  <div className={styles.authorWrapper}>
                    <div className={styles.author}>
                      <SoopAvatarCommon
                        mode='button'
                        onClick={() => handleHomeClick(user.userId)}
                        size={24}
                        userId={user.userId}
                        variant='default'
                        forceUpdate={getUserLoginId() === user.userId}
                      />
                      {index <= 1 ? (
                        <SoopIcon
                          name={
                            index === 0
                              ? 'icoSupportRank1'
                              : index === 1
                                ? 'icoSupportRank2'
                                : 'icoSupportRank3'
                          }
                          inheritColors={false}
                          className={styles.icon}
                          width={'16px'}
                          height={'16px'}
                        />
                      ) : (
                        ''
                      )}
                    </div>
                    <button type='button' className={styles.nick}>
                      <ChannelIctWrapper
                        userId={user.userId}
                        style={{zIndex: 2000}}>
                        <TextEllipsis as='span' line={1}>
                          {user.userNickname}
                        </TextEllipsis>
                      </ChannelIctWrapper>
                    </button>
                  </div>
                  <span
                    className={clsx(
                      styles.badge,
                      index <= 4 && styles['topfan'],
                    )}>
                    {index === 0
                      ? ChannelT('회장')
                      : index === 1
                        ? ChannelT('부회장')
                        : gradeOrderI18nHelper(index + 1)}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </SoopLayer.Content>
      </div>
    </SoopLayer>
  );
};

export default TopfanLayer;
